module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "preface-title"
  }, [_c('a', {
    attrs: {
      "href": "#/toc#toc-preface001"
    }
  }, [_vm._v("List of Illustrations")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "href": "#/preface003#fig001"
    }
  }, [_vm._v("Iris MacFarlane and her children, Assam, 1950")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter002#fig002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A London Tavern, 1600")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter004#fig003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A traditional Japanese Tea Ceremony")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter006#fig004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Clippers owned by the East India Tea Company, circa 1860")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter008#fig005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Horniman’s Tea Advertisement 1880–1899")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter010#fig006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tibetan men carrying brick tea from China, circa 1900")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter012#fig007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Elephants clearing a plantation, Assam, 1880")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter014#fig008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pleasure Brand Advertisement, 1888")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter016#fig009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mazawattee tea/John Bull advertisement, 1890")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter018#fig010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A typical Chinese plantation")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter020#fig011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Henry Cotton, Chief Commissioner of Assam in 1896")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter022#fig012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Women working on plantation, circa 1990")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter024#fig013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A herbal pharmacopoeia in Tokyo")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter026#fig014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Camellia Sinensis, 19th century")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37c8b0a3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/preface001.vue
// module id = 66
// module chunks = 0